<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gOFhwp/tc-custom/9781466865709.jpg?1738254552507" alt="This image is the cover for the book Necessity, Thessaly"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Necessity, Thessaly
      </h1>
      <p class="bookDescription body article font2">
        <p><b>2017 Sunburst Award for Adult Fiction Finalist</b><br/><br/><b><i>Necessity: </i>the sequel to the acclaimed <i>The Just City</i> and <i>The Philosopher Kings</i>, Jo Walton's tales of gods, humans, and what they have to learn from one another.</b><br/><br/> More than sixty-five years ago, Pallas Athena founded the Just City on an island in the eastern Mediterranean, placing it centuries before the Trojan War, populating it with teachers and children from throughout human history, and committing it to building a society based on the principles of Plato's <i>Republic.</i> Among the City's children was Pytheas, secretly the god Apollo in human form.<br/><br/> Sixty years ago, the Just City schismed into five cities, each devoted to a different version of the original vision.<br/><br/> Forty years ago, the five cities managed to bring their squabbles to a close. But in consequence of their struggle, their existence finally came to the attention of Zeus, who can't allow them to remain in deep antiquity, changing the course of human history. Convinced by Apollo to spare the Cities, Zeus instead moved everything on the island to the planet Plato, circling its own distant sun.<br/><br/> Now, more than a generation has passed. The Cities are flourishing on Plato, and even trading with multiple alien species. Then, on the same day, two things happen. Pytheas dies as a human, returning immediately as Apollo in his full glory. And there's suddenly a human ship in orbit around Plato—a ship from Earth. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jo Walton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1bfa67f6